<template>
  <Modal v-model="modal" :title="$t('title.w54')" :mask-closable="false">
    <div>
      <Alert type="warning" class="alert" show-icon>{{$t('msg.m10')}}</Alert>
      <div class="info">
        <Row>
          <Col span="8">
            <b>{{$t('label.w160')}}</b>
          </Col>
          <Col span="16">
            <span>{{info.OperatorName}}</span>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <b>{{$t('label.w195')}}</b>
          </Col>
          <Col span="16">
            <span>{{info.OperatorAccount}}</span>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <b>{{$t('label.w162')}}</b>
          </Col>
          <Col span="16">
            <span>{{info.OperatorVerifyInfo}}</span>
          </Col>
        </Row>
      </div>
      <Row class="item" type="flex" align="middle">
        <Col span="7">
          <b>{{$t('label.w96')}}</b>
        </Col>
        <Col span="17">
          <span class="dn">{{info.Name}}</span>
        </Col>
      </Row>
      <Row class="item" type="flex" align="middle">
        <Col span="7">
          <b>{{$t('label.w197')}}</b>
        </Col>
        <Col span="17">
          <span class="amount">¥ {{info.CreditAmount | money}}</span>
        </Col>
      </Row>
      <div class="agree">
        <Checkbox v-model="agree">{{$t('other.w63')}}<a href="javascript:;"  @click="protocolShow([8])">{{$t('other.w117')}}</a></Checkbox>
      </div>
    </div>
    <template slot="footer">
      <Button type="primary" :loading="loading" :disabled="!agree" @click="submit">{{$t('btn.b12')}}</Button>
    </template>
    <Protocol ref="Protocol" @yes="agree=true" @no="agree=false"/>
  </Modal>
</template>
<script>
import Protocol from "@/components/protocolModal";
export default {
  components:{Protocol},
  data() {
    return {
      modal: false,
      info: {},
      agree:false,
      loading:false
    };
  },
  methods:{
    submit(){
      let id=this.info.Id
      this.loading=true
      this.$axios.post('/Member/RZJPledge/ApplyPledge',{
        pledgeId:id
      })
      .then(res=>{
        this.loading=false
        this.agree=false
        res.throw()
        this.modal=false
        if(!res.err) this.$emit('done')
      })
    },
     protocolShow(arr){
      this.$refs.Protocol.type=arr
      this.$refs.Protocol.modal=true
    }
  }
};
</script>
<style lang="less" scoped>
.alert {
  margin-top: -10px;
  font-size: 13px;
  margin-bottom: 20px;
}
.info {
  background: #f1f2f5;
  padding: 10px 20px;
  font-size: 14px;
  line-height: 35px;
  margin-bottom: 10px;
}
b {
  font-weight: normal;
  color: #7b7b7c;
}
.item {
  padding: 10px 0;
  .dn {
    font-size: 18px;
    color: #000;
    font-weight: bold;
  }
  .amount {
    color: #ff6106;
    font-size: 18px;
    font-weight: bold;
  }
}
.agree{
  margin-top: 10px;
}
</style>
